import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '../ui/button';
import { CiCircleRemove } from 'react-icons/ci';
import Image from 'next/image';
import logo from '@/assets/logo.png';
import { LoginFunction } from '..';
import { ReactNode, useState } from 'react';
import { useAppSelector } from '@/lib/RTK/hooks';
import { IoPersonSharp } from 'react-icons/io5';

interface loginProps {
    pathNameRoute?: string;
    buttonElement?: ReactNode;
    showModal?: boolean;
    mainLogin?: boolean;
    setShowLoginForm?: (data: boolean) => void;
    endFunction?: () => void;
}
const LoginFormModal = (props: loginProps) => {
    const { buttonElement } = props;
    const { postionLogin_numberor_very } = useAppSelector(
        (state) => state.auth_token_slice,
    );
    const [open, setOpen] = useState(false);
    const [showRegister, setShowRegister] = useState(false);

    return (
        <Dialog.Root
            open={props.showModal ? props.showModal : open}
            onOpenChange={(isOpen) => {
                if (props.setShowLoginForm) {
                    props.setShowLoginForm(isOpen);
                } else {
                    setOpen(isOpen);
                }

                if (!isOpen) {
                    setShowRegister(false);
                }
            }}
        >
            <Dialog.Trigger asChild>
                {buttonElement ? (
                    buttonElement
                ) : (
                    <Button
                        aria-label="ورود"
                        name="login"
                        variant={'blue'}
                        className="xl:!px-4 !px-3 !ring-0 focus-visible:!ring-0"
                    >
                        <IoPersonSharp className="text-xl md:!ml-2" />
                        <span className="md:!block hidden font-medium">
                            ورود
                        </span>
                    </Button>
                )}
            </Dialog.Trigger>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0  z-50 bg-[#0000002b] opacity-100" />
                <Dialog.Content
                    className={`${
                        showRegister
                            ? '!py-8'
                            : 'pb-9 pt-[30px] md:!pt-[40px] md:!pb-[50px]'
                    } flex_col justify-center items-center gap-3 z-[50] !rounded-2xl data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[600px] translate-x-[-50%] translate-y-[-50%] bg-white px-5 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none`}
                >
                    <Dialog.Title className="sr-only"></Dialog.Title>
                    <div className={`w-full md:!px-4 justify-between flex flex-col items-center ${showRegister ? 'md:!overflow-y-hidden overflow-x-hidden overflow-y-scroll' : ''}`}>
                        {!showRegister && (
                            <Image
                                height={52}
                                width={200}
                                src={logo}
                                alt="درمان شیرین"
                                className="bg-cover self-center"
                            />
                        )}
                        <div
                            className={`${
                                showRegister ? 'pt-0' : ' pt-5'
                            } w-full md:!pt-0`}
                        >
                            <p
                                className={`${
                                    showRegister
                                        ? 'pb-5 text-center !text-[17px] !font-bold'
                                        : ''
                                } font-semibold pb-2`}
                            >
                                {postionLogin_numberor_very === 'number'
                                    ? 'ورود به حساب کاربری'
                                    : showRegister
                                    ? 'لطفا اطلاعات خود را تکمیل کنید'
                                    : 'دریافت کد تایید'}
                            </p>
                            {postionLogin_numberor_very === 'number' ? (
                                <p className="text-sm text-[#222222A3] font-medium">
                                    برای استفاده از خدمات درمان شیرین، شماره
                                    موبایل خود را وارد کنید.
                                </p>
                            ) : (
                                ''
                            )}
                        </div>

                        <LoginFunction
                            showRegister={showRegister}
                            setShowRegister={setShowRegister}
                            endFunction={props.endFunction}
                            mainLogin={props.mainLogin}
                        />
                    </div>
                    <Dialog.Close asChild>
                        <button
                            className="font-bold text-2xl hover:bg-violet4 focus:shadow-violet7 absolute top-[10px] left-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
                            aria-label="Close"
                        >
                            <CiCircleRemove />
                        </button>
                    </Dialog.Close>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default LoginFormModal;
